import styled from '@emotion/styled';
import {mixinFloatingSideBar} from 'webapp-lib/styling';

export const ClearInfoNotificationsButton = styled.span``;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: var(--gutter);
  gap: var(--gutter-small);
  font-weight: var(--font-weight-thin);

  ${ClearInfoNotificationsButton} {
    margin-left: auto;
  }
`;

export const StyledNotificationOverview = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: var(--gutter-small) var(--gutter) var(--gutter);
`;

export const NotificationsWrapper = styled.div`
  ${mixinFloatingSideBar}

  .SubTabBar {
    margin-bottom: var(--gutter);
  }
`;
